export default "__VITE_ASSET__ydglmZ1s__"